module.exports = __webpack_public_path__ + "static/media/slim-prata.fa74fe37.jpg";